import type { IDateFormat } from '../types';

const DATE_FORMATS: IDateFormat[] = [
  {
    "countryCode": "AF",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 6
  },
  {
    "countryCode": "AX",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "AL",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "DZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "AS",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "AD",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "AO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "AI",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "AQ",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "AG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "AR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "AM",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "AW",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "AU",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "AT",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "AZ",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "BH",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "BD",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "BB",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BY",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "BE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "BJ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BT",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 0
  },
  {
    "countryCode": "BO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BQ",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "BA",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "BW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "BV",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "BR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "IO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BG",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "BF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BI",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "KH",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "CM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "CV",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "KY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TD",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CL",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "CN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CX",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "KM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CK",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "HR",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "CU",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CW",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "CY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CZ",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "CD",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "DK",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "DJ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "DM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "DO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "EC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "EG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "SV",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "GQ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "ER",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "EE",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "SZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "ET",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "FK",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "FO",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "FJ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "FI",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "FR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "PF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GE",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "DE",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "GH",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GI",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GL",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "GD",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GP",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GU",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "GT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "GG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "HT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "HM",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "HN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "HK",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "HU",
    "format": "YYYY.MM.DD",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "IS",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 0
  },
  {
    "countryCode": "IN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "ID",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "IR",
    "format": "YYYY/MM/DD",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "IQ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "IE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "IL",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 0
  },
  {
    "countryCode": "IT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "CI",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "JM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "JP",
    "format": "YYYY/MM/DD",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "JE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "JO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "KZ",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "KE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "KI",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "XK",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "KW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "KG",
    "format": "YYYY-DD-MM",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "LA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "LV",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "LB",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "LS",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "LR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "LY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "LI",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "LT",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "LU",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "MG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MV",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 5
  },
  {
    "countryCode": "ML",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "IM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MH",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "MQ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MU",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "YT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MX",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "FM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MD",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "MC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MN",
    "format": "YYYY.MM.DD",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "ME",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "MS",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "MM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "NA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NR",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NP",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 0
  },
  {
    "countryCode": "NL",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "NC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NI",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "NE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NU",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "KP",
    "format": "YYYY.MM.DD",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "MK",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "MP",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "NO",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "OM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "PK",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "PW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "PS",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "PA",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "PG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "PY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "PE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "PH",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "PN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "PL",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "PT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "PR",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "QA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "RE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "RO",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "RU",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "RW",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "SH",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "KN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "LC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "PM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "VC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "BL",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "MF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "WS",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "SM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "ST",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "SA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "SN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "RS",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "SC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "SL",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "SG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "SX",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "SK",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "SI",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "SB",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "SO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "ZA",
    "format": "YYYY/MM/DD",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "GS",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "KR",
    "format": "YYYY.MM.DD",
    "separator": ".",
    "weekStart": 0
  },
  {
    "countryCode": "SS",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "ES",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "LK",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "SD",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "SR",
    "format": "DD-MM-YYYY",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "SJ",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "SE",
    "format": "YYYY-MM-DD",
    "separator": "-",
    "weekStart": 1
  },
  {
    "countryCode": "CH",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "SY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 6
  },
  {
    "countryCode": "TW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "TJ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TH",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "BS",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "GM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TL",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TK",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TO",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TT",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "TN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TR",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "TM",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "TC",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "TV",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "UG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "UA",
    "format": "DD.MM.YYYY",
    "separator": ".",
    "weekStart": 1
  },
  {
    "countryCode": "AE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "GB",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "US",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "UM",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "UY",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "UZ",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "VU",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "VA",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "VE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "VN",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "VG",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "VI",
    "format": "MM/DD/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "WF",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "EH",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "YE",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  },
  {
    "countryCode": "ZM",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 1
  },
  {
    "countryCode": "ZW",
    "format": "DD/MM/YYYY",
    "separator": "/",
    "weekStart": 0
  }
];

export default DATE_FORMATS;
